import { Injectable } from '@angular/core';
import { HotelProductService } from './hotel-product.service';
import { BaseProductService } from './base-product.service';
import { InsuranceProductService } from './insurance-product.service';
import { ExperienceProductService } from './experience-product.service';
import { TicketProductService } from './ticket-product.service';
import { FlyProductService } from './fly-product.service';
// Importar otros servicios de categorías...

@Injectable({
  providedIn: 'root'
})
export class ProductFactoryService {
  private productServices: Map<number, BaseProductService>;

  constructor(
    private hotelProductService: HotelProductService,
    private flyProductService: FlyProductService,
    private experienceProductService: ExperienceProductService,
    private ticketProductService: TicketProductService,
    private insuranceProductService: InsuranceProductService
    // Inyectar otros servicios...
  ) {
    this.productServices = new Map();
    this.registerProductServices();
  }

  private registerProductServices(): void {
    this.productServices.set(1, this.hotelProductService); // HOTEL
    // this.productServices.set(3, this.flyProductService); // VUELOS
    this.productServices.set(6, this.experienceProductService), // EXPERIENCIA
    this.productServices.set(9, this.ticketProductService), // TICKET
    this.productServices.set(10, this.insuranceProductService) // ASISTENCIA
    // Registrar otras categorías...
  }

  getProductService(categoryId: number): BaseProductService {
    const service = this.productServices.get(categoryId);
    if (!service) {
      throw new Error(`No product service registered for category ID: ${categoryId}`);
    }
    return service;
  }

  hasProductService(categoryId: number): boolean {
    return this.productServices.has(categoryId);
  }
}
